export const GRID_SIZE = 64;
export const CARD_PIXEL_SIZE = 6;
export const ROOM_CAPACITY = 4;

export const PALETTE = [
  "#1a1a2e",
  "#16213e",
  "#0f3460",
  "#533483",
  "#e94560",
  "#f5a623",
  "#f8e71c",
  "#7ed321",
  "#4a90d9",
  "#50e3c2",
  "#ffffff",
  "#d0d0d0",
  "#9b9b9b",
  "#4a4a4a",
  "#000000",
  "#ff6b6b",
  "#ffd93d",
  "#6bcb77",
  "#4d96ff",
  "#c77dff",
  "#ffb347",
  "#87ceeb",
  "#dda0dd",
  "#98fb98",
  "#ff69b4",
  "#8b4513",
  "#d2691e",
  "#f4a460",
  "#ffe4b5",
  "#ffdab9",
] as const;

export const CARD_TYPES = [
  { label: "🔥 Fire", color: "#ff6b35", typeKey: "Fire" },
  { label: "💧 Water", color: "#4d96ff", typeKey: "Water" },
  { label: "🌿 Nature", color: "#6bcb77", typeKey: "Nature" },
  { label: "⚡ Electric", color: "#ffd93d", typeKey: "Electric" },
  { label: "🔮 Mystic", color: "#c77dff", typeKey: "Mystic" },
  { label: "🌑 Shadow", color: "#9b9b9b", typeKey: "Shadow" },
] as const;

export const FRAME_STYLES = [
  { id: "plain", name: "Plain", icon: "▭" },
  { id: "ornate", name: "Ornate", icon: "✦" },
  { id: "circuit", name: "Circuit", icon: "⊡" },
  { id: "runic", name: "Runic", icon: "ᚻ" },
  { id: "crystal", name: "Crystal", icon: "◇" },
  { id: "vines", name: "Vines", icon: "❧" },
  { id: "flames", name: "Flames", icon: "▲" },
  { id: "galaxy", name: "Galaxy", icon: "★" },
] as const;

export const FRAME_WEIGHTS = [
  { id: "thin", px: 2, label: "—" },
  { id: "medium", px: 3, label: "──" },
  { id: "thick", px: 5, label: "━" },
] as const;

export const TOOLS = [
  { id: "draw", icon: "✒️", label: "Fine Tip" },
  { id: "ink", icon: "🖍️", label: "Ink" },
  { id: "fill", icon: "🪣", label: "Fill" },
  { id: "erase", icon: "🧽", label: "Scrub" },
] as const;

export const BRUSH_SIZES = [1, 2, 4] as const;
